<div class="list-item-container">
  <ng-content select="[list-item-heading]"></ng-content>
  <ng-content select="[list-item-text]"></ng-content>
  <ng-content></ng-content>
</div>
